import Box from '@mui/material/Box'
import PeopleIcon from '@mui/icons-material/People'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'

import HeadingWithIcon from '@/components/heading-with-icon'
import type { HouseholdMember } from '@/types'

export default function Payers({
    householdMembers,
    numberOfMembers,
} : {
    householdMembers: HouseholdMember[]
    numberOfMembers: number | null
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <HeadingWithIcon
                text={`Poplatníci${householdMembers.length > 0 ? ` (${householdMembers.length})` : ''}`}
                icon={<PeopleIcon />}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
                {householdMembers.map(member => (
                    <Box key={member.id}
                        sx={(theme) => ({
                            display: 'flex',
                            gap: 1,
                            backgroundColor: '#fff',
                            border: `1px solid ${theme.palette.customGrey.cardBorder}`,
                            borderRadius: 2.5,
                            paddingX: 1,
                            paddingY: 1.5,
                        })}
                    >  
                        <AccountCircleIcon sx={{ color: 'customLightGreen.darker' }}/>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.3,
                            flexGrow: 1,
                            color: 'customGrey.tableText'
                        }}>
                            <Box>
                                {member.first_name ?? '-'} {member.last_name ?? '-'}
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                gap: 1.5,
                                fontSize: '15px',
                                pr: 1,
                                color: 'customGrey.secondaryText',
                            }}>
                                <Box sx={{
                                    flexGrow: 1,
                                }}>
                                    {member.born}
                                </Box>
                                <Box sx={{
                                    flexShrink: 0,
                                }}>
                                    VS: {member.variable_symbol}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ))}
                {householdMembers.length === 0 &&
                    <Box>
                        {numberOfMembers ? 'Celkový počet: '+numberOfMembers : 'Zatím nedoplněno v EOKU'}
                    </Box>
                }
            </Box>
        </Box>
    )
}
